/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import agIconSet from './svg/iconset/ag-icon-set.svg';

/* eslint-enable import/no-unresolved, import/default */

const dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-\=]*?(base64)?,(.*)$/i;//eslint-disable-line no-useless-escape

/*@ngInject*/
export default function AgConfig($mdIconProvider, ngMdIconServiceProvider) {

    $mdIconProvider.iconSet('ag', agIconSet);

    var iconSet = loadByDataUrl(agIconSet);
    ngMdIconServiceProvider.addShape('ag:weather_station', iconSet.querySelector('#weather_station').innerHTML);

    function loadByDataUrl(url) {
        var results = dataUrlRegex.exec(url);
        var isBase64 = /base64/i.test(url);
        var data = isBase64 ? window.atob(results[2]) : results[2]; //eslint-disable-line
        return angular.element(data)[0];
    }

}

